import React from 'react'
import BlogImage from './BlogImage'
import { DOC_TYPE_INFO, DEFAULTS } from '@constants/articles/docTypes'
import mix from '@utils/styles/mix'

import heroStyles from '@components/blog/styles/HeroImage.module.css'
import styles from '@components/blog/styles/ImageWrapper.module.css'

const SRC = '/assets/baners/search/optimized/samochody-auta-ogloszenia-motoryzacyjne.webp'
const ALT = 'Samochody osobowe blog'

function HeroImage ({ src, alt, title, onMobile = false, docType = null }) {

    src = src || srcFromDocType(docType, onMobile)
    alt = alt || altFromDocType(docType)

    return (
        <section className={mix([heroStyles.hero, styles.wrapper])}
            key={String(docType)}>

            <BlogImage
                src={src || SRC}
                alt={alt || ALT}
                title={title} />
        </section>
    )
}

function srcFromDocType (docType, onMobile) {
    return `${DEFAULTS.BANER_PATH}${DOC_TYPE_INFO[docType][onMobile
        ? 'mobileBaner'
        : 'baner']}.webp`
}

function altFromDocType (docType) {
    return DOC_TYPE_INFO[docType].heading
}

export default HeroImage